// extracted by mini-css-extract-plugin
export default {"profile-info":"ProfileInfo_profile-info__3-ed6","profile-info__divider":"ProfileInfo_profile-info__divider__sI3gR"};